import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../../core/services/settings.service';
import { RouterState, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error500',
  templateUrl: './error500.component.html',
  styleUrls: ['./error500.component.scss']
})
export class Error500Component implements OnInit {

  public message: string;
  constructor(public settings: SettingsService, private route: ActivatedRoute) { }

  public ngOnInit() {

    this.route.queryParams.subscribe(p => {
      console.log(p);
    });
  }

}
